import React from 'react';
import { Page } from '../Page';
import { Brain, Zap, Moon } from 'lucide-react';
export function SupplementAshwagandha() {
  return <Page pageNumber={32} variant="light" data-id="element-2155">
      <div className="flex h-full gap-10" data-id="element-2156">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2157">
          <img src="https://cdn.magicpatterns.com/uploads/d3YyBiJkGkHonv19FV4VGU/pasted-image.png" alt="Thorne Ashwagandha" className="w-full max-w-[280px] object-contain" data-id="element-2158" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2159">
          <div className="mb-6 pt-4" data-id="element-2160">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2161">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2162">
              Ashwagandha
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2163">
              Stress management for sustainable weight loss
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2164" />
          </div>

          <div className="mb-8" data-id="element-2165">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2166">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2167">
              Stress management is critical on GLP-1 medications. Elevated
              cortisol can drive cravings, disrupt sleep, and stall weight loss.
              Ashwagandha (Shoden® extract) directly supports the
              stress-sleep-energy triad that GLP-1 patients often struggle with.
              Just 1 capsule per day = simple compliance.
            </p>
          </div>

          <div className="mb-8" data-id="element-2168">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2169">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2170">
              <li className="flex gap-2" data-id="element-2171">
                <Brain className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2172" />
                <span data-id="element-2173">
                  Modulates cortisol and DHEA during times of stress, reducing
                  stress-driven eating
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2174">
                <Moon className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2175" />
                <span data-id="element-2176">
                  Supports the sleep quality covered on your Sleep page, calming
                  without sedation
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2177">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2178" />
                <span data-id="element-2179">
                  Enhances daytime energy and mental clarity, resisting fatigue
                  during caloric deficit
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2180">
                <span className="text-tealslate shrink-0" data-id="element-2181">•</span>
                <span data-id="element-2182">
                  Shoden® extract at 35% withanolide glycosides, clinically
                  effective at smaller servings
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-2183">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-2184">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2185">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-2186">
                <strong data-id="element-2187">1 capsule daily</strong>. Can be taken morning or
                evening
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-2188">
                30 capsules per bottle • Shoden® ashwagandha extract
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-2189">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2190" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2191">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}